// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6466) return "static/chunks/6466-6740f204bae34db1.js";
	if (chunkId === 1891) return "static/chunks/1891-fb4608cb2d236c09.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9923 ? "8e095c31" : chunkId) + "." + {"2017":"c8600b021182e43b","4442":"412148c90a175b9e","4910":"0b94e3c1dc266520","5273":"7515eb3e9d4277da","5993":"41722c01aa788d1d","7281":"1ff46b939d3d76d0","7746":"5a3d2ce730813fde","8009":"fd9b187f95fd17ca","9591":"252650190bd9d83f","9923":"4ed98730892a0ebc"}[chunkId] + ".js";
};